import { FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';


export default function getCallbackFromProps(props, canPlayFullOrPreview, fullAccessAction) {
  if (canPlayFullOrPreview) {
    return props.onPlayRequest;
  } else if (fullAccessAction === FULL_ACCESS_ACTION_NAMES.SIGN_IN) {
    return props.onPlayMemberOnlyRequest;
  }

  return _.noop;
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/video-overlay/play/callback.js